export default {
      id: "sidebar-divider-usage",
      viewBox: "0 0 355 1",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#sidebar-divider",
      toString: function () {
        return this.url;
      }
    }